import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withHandlers, compose, withStateHandlers, lifecycle } from 'recompose';
import { withFormikField, getFormikError } from 'utils/formik';
import { getHourAndMinutes, formatIncompleteHour, checkIfRealHour } from './utils';

import { setCheckTimes } from 'redux/modules/shipper-order-new/duck';

import { Field, Flexer } from '@ontruck/orc';
import { useDispatch } from 'react-redux';

const enhance = compose(
  withFormikField,
  withStateHandlers(
    () => ({
      temporaryHour: '',
      changingHour: false,
    }),
    {
      setTemporaryHour: () => (hour) => ({
        temporaryHour: hour,
      }),
      setChangingHour: () => (changingHour) => ({
        changingHour: changingHour,
      }),
    }
  ),
  withHandlers({
    changeDayInFormik:
      ({ onTimeChange, form }) =>
      (name, value) => {
        const { setFieldTouched, setFieldValue } = form;

        if (onTimeChange) {
          onTimeChange(name, value, true);
        } else {
          setFieldValue(name, value);
          setFieldTouched(name);
        }
      },
  }),
  withHandlers({
    handleChangeHour:
      ({ field, changeDayInFormik }) =>
      (selectedHour) => {
        const { name, value } = field;

        const hourAndMinutes = selectedHour.split(':');
        const momentObject = moment(value);

        momentObject.set({
          hour: (hourAndMinutes || [])[0],
          minutes: (hourAndMinutes || [])[1],
        });

        const dayAndTime = momentObject.format();

        changeDayInFormik(name, dayAndTime);
      },
  }),
  lifecycle({
    componentDidMount() {
      const { field, setTemporaryHour } = this.props;
      const { value } = field;

      if (value) {
        setTemporaryHour(getHourAndMinutes(value));
      }
    },
    componentWillReceiveProps() {
      const { changingHour, field, setTemporaryHour, temporaryHour } = this.props;
      const { value } = field;
      const temporaryHourIsEmpty = temporaryHour === '';

      if (!value && !changingHour && !temporaryHourIsEmpty) {
        setTemporaryHour('');
      }
    },
  })
);

const Hour = ({
  handleChangeHour,
  field,
  form,
  labelHour,
  setTemporaryHour,
  setChangingHour,
  temporaryHour,
  disabled,
}) => {
  const dispatch = useDispatch();
  return (
    <Fragment>
      <Flexer.Child mLeft="XS">
        <Field
          disabled={disabled}
          onFocus={() => setChangingHour(true)}
          onChange={(e, { value }) => setTemporaryHour(value)}
          onBlur={() => {
            setChangingHour(false);
            if (temporaryHour) {
              const formattedHour = formatIncompleteHour(temporaryHour);
              if (checkIfRealHour(formattedHour)) {
                handleChangeHour(formattedHour, dispatch);
                setTemporaryHour(formattedHour);
                dispatch(setCheckTimes(true));
              } else {
                setTemporaryHour('');
              }
            }
          }}
          label={labelHour}
          value={temporaryHour}
          id="field-m-size"
          size="S"
          persistedPlaceholder="HH:mm"
          width="S"
          maskedProps={!disabled && { mask: '99:99', maskChar: null }}
          invalid={!!getFormikError({ field, form })}
          dataE2E={`shipperOrder_edit__hour_${field.name}`}
        />
      </Flexer.Child>
    </Fragment>
  );
};

Hour.propTypes = {
  disabled: PropTypes.bool,
  handleChangeHour: PropTypes.func,
  setTemporaryHour: PropTypes.func,
  setChangingHour: PropTypes.func,
  field: PropTypes.object,
  form: PropTypes.object,
  labelHour: PropTypes.string,
  temporaryHour: PropTypes.string,
};

export default enhance(Hour);
